import Phaser from "phaser";
import WebFontFile from "./FontLoader";

export default class TitleScreen extends Phaser.Scene{
  preload() {
    const fonts = new WebFontFile(this.load, "Press Start 2P");
    this.load.addFile(fonts);
  }

  create() {
    const width = this.scale.width;
    const height = this.scale.height;
    const title = this.add.text(width / 2, height / 2, "BreakOut", {
      fontFamily: "'Press Start 2P'",
      fontSize: 40
    });
    title.setOrigin(0.5, 0.5);

    const pressSpace = this.add.text(width / 1.5, height / 1.7, 'Press SPACE to Start', {
      fontFamily: "'Press Start 2P'",
      fontSize: 13
    })
    pressSpace.setOrigin(0.5);

    this.input.keyboard.once("keydown-SPACE", () => {
      this.scene.start('game');
    })
  }
}
